module.exports = __webpack_public_path__ + "img/button_obnovenie.b0e27e52.svg";